export default "__VITE_ASSET__49a1e28f__"